<template>
    <div class="accountBox">
        <el-form ref="elForm" :model="formData" :rules="rules" size="medium" class="input">
            <el-form-item prop="username" class="inputItem">
              <span class="sp1">创建账号 :</span>
              <el-input v-model="formData.username" placeholder="账号由小写字母和数字组成，8-20位账号" clearable
              :style="{width: '100%'}"></el-input>
            </el-form-item>
            <el-form-item prop="password" class="inputItem">
              <span class="sp1">设置密码 :</span>
              <el-input v-model="formData.password" placeholder="密码由字母数字组成，8-20位" clearable show-password
              :style="{width: '100%'}"></el-input>
            </el-form-item>
            <el-form-item prop="confirmPassword" class="inputItem">
              <span class="sp1">确认密码 :</span>
              <el-input v-model="formData.confirmPassword" placeholder="再次输入确认密码" clearable show-password
              :style="{width: '100%'}"></el-input>
            </el-form-item>
            <div class="btn" @click="register">下一步</div>
        </el-form>
    </div>
</template>

<script>
import LoginService from '@/services/login';
export default {
	data() {
		return {
			formData: {
				mobile: '',
				field104: undefined,
				field105: undefined,
			},
			rules: {
				username: [{
					required: true,
					message: '请输入账号',
					trigger: 'blur'
				}, {
					pattern: /^(?=.*[0-9])(?=.*[a-z])[0-9a-z]{8,20}$/,
					message: '账号由小写字母和数字组成，8-20位账号',
					trigger: 'blur'
				}],
				password: [{
					pattern: /^(?=.*[0-9])(?=.*[a-zA-Z])[0-9A-Za-z]{8,20}$/,
					message: '密码由小写字母和数字组成，8-20位账号',
					trigger: 'blur'
				},{
					required: true,
					message: '请输入密码',
					trigger: 'blur'
				}],
				confirmPassword: [{
					pattern: /^(?=.*[0-9])(?=.*[a-zA-Z])[0-9A-Za-z]{8,20}$/,
					message: '密码由小写字母和数字组成，8-20位账号',
					trigger: 'blur'
				},{
					required: true,
					message: '请确认密码',
					trigger: 'blur'
				}],
			},
		}
	},
	methods: {
		register() {
			this.$refs['elForm'].validate((valid) => {
				if(this.formData.password != this.formData.confirmPassword) {
					this.$message.error('两次密码不一致')
					return false;
				}
				if (!valid) return false;
				LoginService.register(this.formData).then(res => {
					res.code == 1 ? this.$message.error(res.message) : this.$message.success('注册成功！');
					console.log(res)
					this.$emit('resSuccess', res.result.id)
				})
			})
		}
	}
}
</script>

<style lang="scss">
.accountBox{
	.sp1{
		font-size: 14px;
		color: #fff;
	}
	.input{
		width: 464px;
		margin: 0 auto;
	}
	.el-input__inner{
		background-color: rgba(36, 36, 58, 1);
		border: none
	}
	.el-input__inner::-webkit-input-placeholder{
		color: rgba(118, 118, 149, 1);
		font-size: 14px;
	}
	.el-input__inner::-moz-placeholder{   /* Mozilla Firefox 19+ */
		color: rgba(118, 118, 149, 1);
		font-size: 14px;
	}
	.el-input__inner:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
		color: rgba(118, 118, 149, 1);
		font-size: 14px;
	}
	.el-input__inner:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
		color: rgba(118, 118, 149, 1);
		font-size: 14px;
	}
	.btn{
		background-color: #54548A;
		color: #fff;
		text-align: center;
		line-height: 50px;
		height: 50px;
		border-radius: 12px;
		opacity: 0.6;
		font-size: 16px;
		cursor: pointer;
		margin-top: 48px;
	}
}
</style>
